export const userCategoryCodes = {
  WEBPOS_USERS: 'WEBPOS_USERS'
}
